import {useCallback} from 'react'
import {Box, Image, Stack} from '@primer/react-brand/esm'
import {ContentfulForm} from '@github-ui/swp-core/components/contentful/ContentfulForm'
import {getImageSources} from '@github-ui/swp-core/lib/utils/images'

import type {ResourceDetailsPage} from '../../lib/types/contentful'
import {appendFeatureFlagsToUrl} from '../../lib/utils'

import styles from './ResourceDetailsPage.module.css'
import {ssrSafeLocation} from '@github-ui/ssr-utils'

type AsideProps = {
  component: ResourceDetailsPage
  locationUrl?: URL
}

export default function Aside({component, locationUrl}: AsideProps) {
  const {featuredImage, form} = component.fields

  const handleOnSubmitted = useCallback(() => {
    if (locationUrl) {
      const queryParams = new URLSearchParams(ssrSafeLocation.search)
      const featureFlags = queryParams.get('_features') || ''
      window.location.href = appendFeatureFlagsToUrl(`${locationUrl.href}/confirmation`, featureFlags)
    }
  }, [locationUrl])

  if (!(featuredImage || form)) {
    return null
  }

  return (
    <Stack padding="none" gap={32} data-testid="resource-details-aside">
      {featuredImage ? (
        <Box className={styles.hiddenOnMobile}>
          <Image
            as="picture"
            src={`${featuredImage.fields.file.url}?fm=webp`}
            sources={getImageSources(featuredImage.fields.file.url, {maxWidth: 640})}
            alt={featuredImage.fields.description || ''}
            borderRadius="medium"
            aspectRatio="1:1"
            loading="lazy"
          />
        </Box>
      ) : null}
      {form ? (
        <Box id="content-form">
          <ContentfulForm
            component={form}
            headingProps={{as: 'h2', size: '6'}}
            onSubmitted={handleOnSubmitted}
            padding="none"
          />
        </Box>
      ) : null}
    </Stack>
  )
}
